
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44.8","height":"37.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"フッター　お知らせ","fill":"#6d6c6f"}},[_c('text',{attrs:{"transform":"translate(.4 36.5)","stroke":"#6d6c6f","stroke-width":".4","font-size":"11","font-family":"HiraKakuProN-W3, Hiragino Kaku Gothic ProN"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('お知らせ')])]),_c('path',{attrs:{"d":"M31.9 17v1h-18v-1l2-2V9a6.99 6.99 0 015-6.71V2a2 2 0 014 0v.29a6.99 6.99 0 015 6.71v6l2 2m-7 2a2 2 0 01-4 0"}})])])
          )
        }
      }
    